import * as React from 'react';
import { connect } from 'react-redux';
import {
    fetchPublicacion,
    editPublicacion,
    fetchTiposPublicacion,
    fetchVariaciones
} from '../../../../actions/publicacionesActions';
import { formatCurrencyToNumber } from '../../../../helper/publicacionHelper';
import { createPublicacionApi } from '../../../../api/axios';
import { toast } from 'react-toastify';
import Tab from '../../../General/Tab'
import DatosBasicos from './DatosBasicos';
import PrecioPago from './PrecioPago';
import Entrega from './Entrega';
import Imagenes from './Imagenes';
import Estado from './Estado';
import Garantia from './Garantia'

class PublicacionNew extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 0,
            tabs: [
                { name: "Datos Básicos ", icon: "ti-home", content: <DatosBasicos isEditing={true} /> },
                { name: "Precio y Medio de Pago", icon: "sl-icon-wallet", content: <PrecioPago /> },
                { name: "Entrega ", icon: "sl-icon-globe", content: <Entrega /> },
                { name: "Imagenes ", icon: "sl-icon-picture", content: <Imagenes inCreate={true} /> },
                { name: "Estado ", icon: "sl-icon-layers", content: <Estado inCreate={true} /> },
                { name: "Garantía ", icon: "ti-home", content: <Garantia idSeller={this.props.match.params.idSeller} id={this.props.match.params.id} isEditing={true} /> },
            ]
        }
    };

    componentDidMount() {
        this.props.editPublicacion({});
        this.props.fetchPublicacion();
        this.props.fetchTiposPublicacion(this.props.match.params.idSeller);
        this.props.fetchVariaciones();
    }

    onSubmit = (event) => {
        event.preventDefault();

        let publicacion = { 
            ...this.props.publicacion, 
            estado: "activo", 
            idTipoPublicacion: parseInt(this.props.publicacion.idTipoPublicacion) 
        };

        publicacion.precioLista = formatCurrencyToNumber(publicacion.precioLista);
        if (publicacion.precioPromocional == null) publicacion.precioPromocional = 0;
        publicacion.precioPromocional = formatCurrencyToNumber(publicacion.precioPromocional);
        publicacion.garantiaFabrica = publicacion.garantiaFabrica ? publicacion.garantiaFabrica : 0;
        publicacion.garantiaExtActiva = publicacion.garantiaFabrica > 0;

        // unused vars pero se asignan a props
        for (let index = 0; index < publicacion.dimensiones.length; index++) {
            let alto = publicacion.dimensiones[index].alto != undefined ? (publicacion.dimensiones[index].alto = parseFloat(publicacion.dimensiones[index].alto)) : 0;
            let ancho = publicacion.dimensiones[index].ancho != undefined ? (publicacion.dimensiones[index].ancho = parseFloat(publicacion.dimensiones[index].ancho)) : 0;
            let profundidad = publicacion.dimensiones[index].profundidad != undefined ? (publicacion.dimensiones[index].profundidad = parseFloat(publicacion.dimensiones[index].profundidad)) : 0;
            let peso = publicacion.dimensiones[index].peso != undefined ? (publicacion.dimensiones[index].peso = parseFloat(publicacion.dimensiones[index].peso)) : 0;
        }

        const req = createPublicacionApi(publicacion);
        req.then(response => {
            toast.success("Publicación creada");
            this.goToPublicaciones();
        }).catch(err => {
            (err.response.data.errores) 
            ? err.response.data.errores.forEach(error => toast.error(error)) 
            : toast.warn("No pudo crearse");
        })
    }

    onChangeActiveTab = (index) => {
        this.setState({ activeTab: index });
    }

    goToPublicaciones = () => {
        this.props.history.push("/Publicaciones");
    }

    render() {
        return (
            <div className="col-sm-12">
                <div className="card">
                    <div className="card-body p-b-0">
                        <h4 className="card-title">Nueva Publicacion</h4>
                        <h5 className="card-subtitle"> {this.props.sellerNombre} </h5>

                        <ul className="nav nav-tabs customtab" role="tablist">
                        {
                            this.state.tabs.map((tab, index) => {
                                if (tab.name != undefined) {
                                    return <div key={index} onClick={() => { this.onChangeActiveTab(index) }}>
                                        <Tab
                                            name={tab.name}
                                            icon={tab.icon}
                                            isActive={(index == this.state.activeTab) ? true : false}
                                        />
                                    </div>
                                }
                            })
                        }
                        </ul>

                        <form className="form-horizontal form-material p-10">
                            <div className="tab-content">
                                {this.state.tabs[this.state.activeTab].content}
                                <button
                                    onClick={this.onSubmit}
                                    className="btn  btn-sm background-rojo-megatone waves-light m-r-10"
                                >
                                    Guardar
                                </button>
                                <button
                                    onClick={this.goToPublicaciones}
                                    className="btn btn-sm btn-light waves-effect waves-light"
                                >
                                    Cancelar
                                </button>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => ({
    publicacion: state.publicaciones.publicacion,
    tipoUsuario: state.general.tipoUsuario,
    sellerNombre: state.general.userName
});

export default connect(mapStateToProps, {
    fetchPublicacion,
    editPublicacion,
    fetchTiposPublicacion,
    fetchVariaciones
})(PublicacionNew);